<!-- @format -->
<image-tag>
    <input id="img-upload" type="file" accept='image/*' onchange="{preview}" class="def-hidden">
    <div id="preview-area" class="def-hidden">
        <canvas id="preview"  class="canvas-size"></canvas>
        <div id="img-del-button"
            class="button button-border button-secondary-mini"
            type="button"
            value="画像を削除する"
            onclick="{remove}"
            data-target=""
        >画像を削除する</div>
    </div>

    <script>
        import debounce from 'debounce-promise';
        import works from "@model/works/api";

        export default {
            works: works,
	        fileReader: new FileReader(),
            preview(e) {
                e.preventDefault()
                const type = e.target.files[0].type.split('/')
                if ('image' != type[0]) {
                    return
                }
                if ('jpeg' != type[1] && 'png' != type[1] && 'gif' != type[1]) {
                    return
                }
                this.works.trigger('preview-img')
                this.$('#preview-area').classList.remove('def-hidden')
                this.fileReader.readAsDataURL(e.target.files[0])
                this.props.onUpload(e.target.files[0])
            },
            previewOgp() {
                let canvas = this.$('#preview')
                let ctx = canvas.getContext('2d')
                let image = new Image();

                image.src = '/public-info/works/api/v1/ogp?url=' + this.works.item.url;
                image.onload = (() => {
                    this.$('#preview-area').classList.remove('def-hidden')
                    canvas.width = image.width;
                    canvas.height = image.height;
                    ctx.drawImage(image, 0, 0);
                    this.$('#img-upload').value = ''
                })
            },
            remove(e) {
                e.preventDefault()
                this.works.thumb_action = 'delete'
                this.works.ogp_action = 'delete'
                this.$('#img-upload').value = ''
                this.$('#preview-area').classList.add('def-hidden')
                this.props.onUpload(null)
            },
            listenerUploadImg() {
                this.$('#img-upload').click()
            },
            listenerClear() {
                this.$('#img-upload').value = ''
                this.$('#preview-area').classList.add('def-hidden')
            },
            onMounted(props, state) {
	            this.fileReader.onload = (()=> {
                    let canvas = this.$('#preview')
                    let ctx = canvas.getContext('2d')
		            let image = new Image();

		            image.src = this.fileReader.result;
                    image.onload = (() => {
                        canvas.width = image.width;
                        canvas.height = image.height;
                        ctx.drawImage(image, 0, 0);
                    })
                })
                this.works.on('preview-ogp', this.previewOgp)
                this.works.on('upload-img', this.listenerUploadImg)
                this.works.on('clear-img', this.listenerClear)
            },
            onUnmounted(props, state) {
                this.works.off('preview-ogp', this.previewOgp)
                this.works.off('upload-img', this.listenerUploadImg)
                this.works.off('clear-img', this.listenerClear)
            }
        }
    </script>
    <style>
        .canvas-size {
            max-width: 500px;
            margin-top: 12px;
        }
        .def-hidden {
            display: none;
        }
    </style>
</image-tag>